// ==========================================================================
// Base
// ==========================================================================

// Prevent # anchors jumping page to top
document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('a[href="#"]').forEach(function(anchor) {
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
        });
    });
});

/**
 * Accept HMR as per: https://vitejs.dev/guide/api-hmr.html & https://nystudio107.com/docs/vite/
 */
if (import.meta.hot) {
	import.meta.hot.accept(() => {
		console.log('HMR')
	})
}